import ScrollPaginationDropdown from './ScrollPaginationDropdown';

export default ScrollPaginationDropdown;
